import React from 'react';
import {
  Control,
  Controller,
  ControllerProps,
  FieldPath,
  FieldPathValue,
  FieldValues,
  UseControllerProps,
} from 'react-hook-form';

interface RenderControllerParameters<
  T extends FieldValues = FieldValues,
> {
  control: Control<T>;
  name: string;
  rules?: UseControllerProps['rules'];
  defaultValue?: unknown;
  render: ControllerProps<T, FieldPath<T>>['render'];
}

const renderController = <
  T extends FieldValues = FieldValues,
>({
    control,
    name,
    rules,
    defaultValue,
    render,
  }: RenderControllerParameters<T>) => (
    <Controller<T, FieldPath<T>>
      control={control}
      name={name as FieldPath<T>}
      rules={
        rules as UseControllerProps<
          T, FieldPath<T>
        >['rules']
      }
      {...(defaultValue === undefined
        ? {}
        : {
          defaultValue: defaultValue as FieldPathValue<
            T, FieldPath<T>
          >,
        })}
      render={render}
    />
  );

export default renderController;
